import { useSelector } from 'react-redux';
import { RootState } from '..';
import { BatchPaymentFormState } from '.';

export const useLoadBatchPayment = (): Partial<BatchPaymentFormState> =>
  useSelector((state: RootState) => state.BatchPayment);
